import { Button } from '@salt/components';
import React, { useCallback } from 'react';
import { resetUserPassword } from '../../api/users';

const ResetPasswordModal = ({ handleResetPasswordModalClose, user, fetchData }) => {
  const onReset = useCallback(() => {
    resetUserPassword({ memberId: user.id })
      .then(() => {
        fetchData();
      })
      .catch(() => {
        console.error('Failed to resend invite to user');
      });
    handleResetPasswordModalClose();
  }, [user]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleResetPasswordModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="text-lg mb-4">Reset Password</div>
        <span className="text-base">
          Send a password reset email to <b>{user.username}</b>?
        </span>

        <div className="mt-4">
          <br />
          <Button
            onClick={handleResetPasswordModalClose}
            type="neutral"
            className="max-w-[146px] h-[36px] ml-auto"
            paddingClassName="px-6"
          >
            Cancel
          </Button>
          <Button
            onClick={onReset}
            type="positive"
            className="max-w-[146px] h-[36px] ml-auto float-right"
            paddingClassName="px-6"
          >
            Send
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
